import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { TopicsFilter } from '#src/app/pages/search/shared/components';

export const TopicsSection: React.FC = () => {
	return (
		<div className="mt-8 md:mt-16">
			<div className="container">
				<Text variant="heading" as="h2" size="small" className="mt-0">
					<Translate value="corgi.search.filters.topic.title" />
				</Text>
				<div className="mt-6 hidden md:block">
					<TopicsFilter chipSize="large" trackingContext="landing_topic" />
				</div>
				<div className="mt-6 block md:hidden">
					<TopicsFilter chipSize="small" trackingContext="landing_topic" />
				</div>
			</div>
		</div>
	);
};
